export default {"src":"/_next/static/media/web3LOGO.05e27610.svg","height":34,"width":237,"blurWidth":0,"blurHeight":0};